module.exports = __webpack_public_path__ + "static/media/ten.6df43008.png";